
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/festivals/[festivalId]",
      function () {
        return require("private-next-pages/festivals/[festivalId]/index.tsx");
      }
    ]);
  